import {setDatasets, setSumLabels} from "../../components/charts/helpers";

export default {
  computed: {
    dataLineCollection() {
      if (Object.keys(this.data.graph_data).length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets()
        };
      }

      return {};
    },
    totalCount () {
      if (this.data.graph_data) {
        return this.data.graph_data.reduce((sum, elem) => {
          return sum + elem[1];
        }, 0);
      }
      return 0;
    },
  },
  methods: {
    getLikes() {
      return this.data.graph_data.map(item => item[1]);
    },
    getDataSets() {
      return [
        {
          label: this.$t('feed.audit.views.body.chart.label'),
          borderColor: '#1989fa',
          borderWidth: 1,
          pointRadius: 3,
          pointBackgroundColor: "#1989fa",
          pointBorderColor: "#1989fa",
          backgroundColor: "transparent",
          data: this.getLikes(),
          showLabel: this.showLabel,
        }
      ];
    },
    getLabels() {
      return this.data.graph_data.map(item => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;

          return [item[0].slice(-2), this.month[month]];
        }

        return item[0];
      });
    }
  },
  data() {
    return {
      month: this.$t('feed.audit.views.body.chart.month'),
      endTime: '23:59:59',
      lineOptions: {
        layout: {
          padding: {
            left: 0,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.3,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
        },
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: function(value, ctx) {
              if (value === 0) {
                return "";
              }

              return value;
            },
            anchor: "end",
            offset: () => {
              return 10;
            },
            align: (ctx) => {
              if (ctx.dataset.data[ctx.dataIndex] === 0) {
                return 'top';
              }

              if (ctx.dataset.data.length) {
                const datasets = setDatasets(ctx);
                if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {

                  const sumLabels = setSumLabels(datasets, ctx);
                  const max = ctx.chart.scales['y-axis-0'].max;
                  const step = Math.round(max/ctx.dataset.data.length);

                  if (sumLabels >= (max - step)) {
                    return  'bottom';
                  }

                  if (ctx.dataIndex === 0) {
                    return 'right';
                  }

                  if (ctx.dataIndex === ctx.dataset.data.length - 1) {
                    return 240;
                  }

                  return 'top';
                }
              }

            },
            font: {
              weight: "normal",
              size: 14,
              family: "Roboto"
            },
            clamp: true,
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
